module.exports = __webpack_public_path__ + "assets/img/slogan-8142f784.png";